export const notificationsKeys = {
  all: ['notifications'] as const,

  notificationUnread: (resource: string | number) =>
    [...notificationsKeys.all, 'unread', resource] as const,
  notificationNew: (resource: string | number) =>
    [...notificationsKeys.all, 'new', resource] as const,
};
